// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"MyPagination_paginationContainer__1x0_P","paginationDiv":"MyPagination_paginationDiv__2XGIo"};